import {FloteError} from "@/lib/errors";

export class ModuleMemberTypeNotResolvedError extends FloteError {

}
